const SavedSearches = [
    {
        'date': '2022-01-01',
        'id': '123456789',
        'report_name': '"Important"',
        'type': 'keyword'
    },
    {
        'date': '2022-01-01',
        'id': '123456789',
        'report_name': 'Quantities',
        'type': 'entity'
    },
    {
        'date': '2022-01-01',
        'id': '123456789',
        'report_name': 'What is legal aid?',
        'type': 'query'
    }
]
export default SavedSearches;